const SKIP_STEPS_BY_PARTICIPANT_TYPE = {
  buyer: ["GBDRNFL"],
};

export function filterStepsForParticipant(steps, participantTypeCode) {
  const skip = SKIP_STEPS_BY_PARTICIPANT_TYPE[participantTypeCode];
  if (!Array.isArray(steps) || !skip?.length) return steps || [];
  return steps.filter((s) => !skip.includes(s?.code));
}
